import Icon from '@ant-design/icons';
import { DeleteOutlined } from '@ant-design/icons';
import '../style.css';

export const showIconDelete = (status) => {
	if (status === 100) return <Icon className="disscount-icon" component={DeleteOutlined} />;
	return '-';
};
